(function ($) {
    !(function (t, e) {
        "use strict";

        function n(t, e, n) {
            var r = t.children(),
                a = !1;
            t.empty();
            for (var i = 0, d = r.length; i < d; i++) {
                var l = r.eq(i);
                if ((t.append(l), n && t.append(n), o(t, e))) {
                    l.remove(), (a = !0);
                    break;
                }
                n && n.detach();
            }
            return a;
        }

        function r(e, n, i, d, l) {
            var s = !1,
                c =
                    "a, table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style",
                u = "script, .dotdotdot-keep";
            return (
                e
                    .contents()
                    .detach()
                    .each(function () {
                        var h = this,
                            f = t(h);
                        if ("undefined" == typeof h) return !0;
                        if (f.is(u)) e.append(f);
                        else {
                            if (s) return !0;
                            e.append(f),
                            !l ||
                            f.is(d.after) ||
                            f.find(d.after).length ||
                            e[e.is(c) ? "after" : "append"](l),
                            o(i, d) &&
                            (s = 3 == h.nodeType ? a(f, n, i, d, l) : r(f, n, i, d, l)),
                            s || (l && l.detach());
                        }
                    }),
                    n.addClass("is-truncated"),
                    s
            );
        }

        function a(e, n, r, a, d) {
            var c = e[0];
            if (!c) return !1;
            var h = s(c),
                f = h.indexOf(" ") !== -1 ? " " : "　",
                p = "letter" == a.wrap ? "" : f,
                g = h.split(p),
                v = -1,
                w = -1,
                m = 0,
                b = g.length - 1;
            if (
                (a.fallbackToLetter &&
                0 === m &&
                0 === b &&
                ((p = ""), (g = h.split(p)), (b = g.length - 1)),
                    a.maxLength)
            )
                (h = i(h.trim().substr(0, a.maxLength), a)), l(c, h);
            else {
                for (; m <= b && (0 !== m || 0 !== b);) {
                    var y = Math.floor((m + b) / 2);
                    if (y == w) break;
                    (w = y),
                        l(c, g.slice(0, w + 1).join(p) + a.ellipsis),
                        r.children().each(function () {
                            t(this).toggle().toggle();
                        }),
                        o(r, a)
                            ? ((b = w),
                            a.fallbackToLetter &&
                            0 === m &&
                            0 === b &&
                            ((p = ""),
                                (g = g[0].split(p)),
                                (v = -1),
                                (w = -1),
                                (m = 0),
                                (b = g.length - 1)))
                            : ((v = w), (m = w));
                }
                if (v == -1 || (1 === g.length && 0 === g[0].length)) {
                    var x = e.parent();
                    e.detach();
                    var C = d && d.closest(x).length ? d.length : 0;
                    if (
                        (x.contents().length > C
                            ? (c = u(x.contents().eq(-1 - C), n))
                            : ((c = u(x, n, !0)), C || x.detach()),
                        c && ((h = i(s(c), a)), l(c, h), C && d))
                    ) {
                        var T = d.parent();
                        t(c).parent().append(d), t.trim(T.html()) || T.remove();
                    }
                } else (h = i(g.slice(0, v + 1).join(p), a)), l(c, h);
            }
            return !0;
        }

        function o(t, e) {
            return (
                t.innerHeight() > e.maxHeight ||
                (e.maxLength && t.text().trim().length > e.maxLength)
            );
        }

        function i(e, n) {
            for (; t.inArray(e.slice(-1), n.lastCharacter.remove) > -1;)
                e = e.slice(0, -1);
            return (
                t.inArray(e.slice(-1), n.lastCharacter.noEllipsis) < 0 &&
                (e += n.ellipsis),
                    e
            );
        }

        function d(t) {
            return {width: t.innerWidth(), height: t.innerHeight()};
        }

        function l(t, e) {
            t.innerText
                ? (t.innerText = e)
                : t.nodeValue
                ? (t.nodeValue = e)
                : t.textContent && (t.textContent = e);
        }

        function s(t) {
            return t.innerText
                ? t.innerText
                : t.nodeValue
                    ? t.nodeValue
                    : t.textContent
                        ? t.textContent
                        : "";
        }

        function c(t) {
            do t = t.previousSibling;
            while (t && 1 !== t.nodeType && 3 !== t.nodeType);
            return t;
        }

        function u(e, n, r) {
            var a,
                o = e && e[0];
            if (o) {
                if (!r) {
                    if (3 === o.nodeType) return o;
                    if (t.trim(e.text())) return u(e.contents().last(), n);
                }
                for (a = c(o); !a;) {
                    if (((e = e.parent()), e.is(n) || !e.length)) return !1;
                    a = c(e[0]);
                }
                if (a) return u(t(a), n);
            }
            return !1;
        }

        function h(e, n) {
            return (
                !!e &&
                ("string" == typeof e
                    ? ((e = t(e, n)), !!e.length && e)
                    : !!e.jquery && e)
            );
        }

        function f(t) {
            for (
                var e = t.innerHeight(),
                    n = ["paddingTop", "paddingBottom"],
                    r = 0,
                    a = n.length;
                r < a;
                r++
            ) {
                var o = parseInt(t.css(n[r]), 10);
                isNaN(o) && (o = 0), (e -= o);
            }
            return e;
        }

        if (!t.fn.dotdotdot) {
            (t.fn.dotdotdot = function (e) {
                if (0 === this.length)
                    return (
                        t.fn.dotdotdot.debug(
                            'No element found for "' + this.selector + '".'
                        ),
                            this
                    );
                if (this.length > 1)
                    return this.each(function () {
                        t(this).dotdotdot(e);
                    });
                var a = this,
                    i = a.contents();
                a.data("dotdotdot") && a.trigger("destroy.dot"),
                    a.data("dotdotdot-style", a.attr("style") || ""),
                    a.css("word-wrap", "break-word"),
                "nowrap" === a.css("white-space") && a.css("white-space", "normal"),
                    (a.bind_events = function () {
                        return (
                            a
                                .bind("update.dot", function (e, d) {
                                    switch (
                                        (a.removeClass("is-truncated"),
                                            e.preventDefault(),
                                            e.stopPropagation(),
                                            typeof l.height)
                                        ) {
                                        case "number":
                                            l.maxHeight = l.height;
                                            break;
                                        case "function":
                                            l.maxHeight = l.height.call(a[0]);
                                            break;
                                        default:
                                            l.maxHeight = f(a);
                                    }
                                    (l.maxHeight += l.tolerance),
                                    "undefined" != typeof d &&
                                    (("string" == typeof d ||
                                        ("nodeType" in d && 1 === d.nodeType)) &&
                                    (d = t("<div />").append(d).contents()),
                                    d instanceof t && (i = d)),
                                        (g = a.wrapInner('<div class="dotdotdot" />').children()),
                                        g
                                            .contents()
                                            .detach()
                                            .end()
                                            .append(i.clone(!0))
                                            .find("br")
                                            .replaceWith("  <br />  ")
                                            .end()
                                            .css({
                                                height: "auto",
                                                width: "auto",
                                                border: "none",
                                                padding: 0,
                                                margin: 0,
                                            });
                                    var c = !1,
                                        u = !1;
                                    return (
                                        s.afterElement &&
                                        ((c = s.afterElement.clone(!0)),
                                            c.show(),
                                            s.afterElement.detach()),
                                        o(g, l) &&
                                        (u =
                                            "children" == l.wrap ? n(g, l, c) : r(g, a, g, l, c)),
                                            g.replaceWith(g.contents()),
                                            (g = null),
                                        t.isFunction(l.callback) && l.callback.call(a[0], u, i),
                                            (s.isTruncated = u),
                                            u
                                    );
                                })
                                .bind("isTruncated.dot", function (t, e) {
                                    return (
                                        t.preventDefault(),
                                            t.stopPropagation(),
                                        "function" == typeof e && e.call(a[0], s.isTruncated),
                                            s.isTruncated
                                    );
                                })
                                .bind("originalContent.dot", function (t, e) {
                                    return (
                                        t.preventDefault(),
                                            t.stopPropagation(),
                                        "function" == typeof e && e.call(a[0], i),
                                            i
                                    );
                                })
                                .bind("destroy.dot", function (t) {
                                    t.preventDefault(),
                                        t.stopPropagation(),
                                        a
                                            .unwatch()
                                            .unbind_events()
                                            .contents()
                                            .detach()
                                            .end()
                                            .append(i)
                                            .attr("style", a.data("dotdotdot-style") || "")
                                            .removeClass("is-truncated")
                                            .data("dotdotdot", !1);
                                }),
                                a
                        );
                    }),
                    (a.unbind_events = function () {
                        return a.unbind(".dot"), a;
                    }),
                    (a.watch = function () {
                        if ((a.unwatch(), "window" == l.watch)) {
                            var e = t(window),
                                n = e.width(),
                                r = e.height();
                            e.bind("resize.dot" + s.dotId, function () {
                                (n == e.width() && r == e.height() && l.windowResizeFix) ||
                                ((n = e.width()),
                                    (r = e.height()),
                                u && clearInterval(u),
                                    (u = setTimeout(function () {
                                        a.trigger("update.dot");
                                    }, 100)));
                            });
                        } else
                            (c = d(a)),
                                (u = setInterval(function () {
                                    if (a.is(":visible")) {
                                        var t = d(a);
                                        (c.width == t.width && c.height == t.height) ||
                                        (a.trigger("update.dot"), (c = t));
                                    }
                                }, 500));
                        return a;
                    }),
                    (a.unwatch = function () {
                        return (
                            t(window).unbind("resize.dot" + s.dotId), u && clearInterval(u), a
                        );
                    });
                var l = t.extend(!0, {}, t.fn.dotdotdot.defaults, e),
                    s = {},
                    c = {},
                    u = null,
                    g = null;
                return (
                    l.lastCharacter.remove instanceof Array ||
                    (l.lastCharacter.remove =
                        t.fn.dotdotdot.defaultArrays.lastCharacter.remove),
                    l.lastCharacter.noEllipsis instanceof Array ||
                    (l.lastCharacter.noEllipsis =
                        t.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis),
                        (s.afterElement = h(l.after, a)),
                        (s.isTruncated = !1),
                        (s.dotId = p++),
                        a.data("dotdotdot", !0).bind_events().trigger("update.dot"),
                    l.watch && a.watch(),
                        a
                );
            }),
                (t.fn.dotdotdot.defaults = {
                    ellipsis: "... ",
                    wrap: "word",
                    fallbackToLetter: !0,
                    lastCharacter: {},
                    tolerance: 0,
                    callback: null,
                    after: null,
                    height: null,
                    watch: !1,
                    windowResizeFix: !0,
                    maxLength: null,
                }),
                (t.fn.dotdotdot.defaultArrays = {
                    lastCharacter: {
                        remove: [" ", "　", ",", ";", ".", "!", "?"],
                        noEllipsis: [],
                    },
                }),
                (t.fn.dotdotdot.debug = function (t) {
                });
            var p = 1,
                g = t.fn.html;
            t.fn.html = function (n) {
                return n != e && !t.isFunction(n) && this.data("dotdotdot")
                    ? this.trigger("update", [n])
                    : g.apply(this, arguments);
            };
            var v = t.fn.text;
            t.fn.text = function (n) {
                return n != e && !t.isFunction(n) && this.data("dotdotdot")
                    ? ((n = t("<div />").text(n).html()), this.trigger("update", [n]))
                    : v.apply(this, arguments);
            };
        }
    })(jQuery),
        jQuery(document).ready(function (t) {
            t(".dot-ellipsis").each(function () {
                var e = t(this).hasClass("dot-resize-update"),
                    n = t(this).hasClass("dot-timer-update"),
                    r = 0,
                    a = t(this).attr("class").split(/\s+/);
                t.each(a, function (t, e) {
                    var n = e.match(/^dot-height-(\d+)$/);
                    null !== n && (r = Number(n[1]));
                });
                var o = {};
                n && (o.watch = !0),
                e && (o.watch = "window"),
                r > 0 && (o.height = r),
                    t(this).dotdotdot(o);
            });
        }),
        jQuery(window).on("load", function () {
            jQuery(".dot-ellipsis.dot-load-update").trigger("update.dot");
        });
})(jQuery);
